import { render } from "./script_editor.vue?vue&type=template&id=4059354a&scoped=true"
import script from "./script_editor.vue?vue&type=script&lang=js"
export * from "./script_editor.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4059354a"]])

export default __exports__